import { SearchFacetFilter } from './search-facet-filter.model';
import { SearchFacetRangeFilter } from './search-facet-range-filter.model';

export class SearchResultFacetItem {
  public token: string;
  public value: string;
  public label: string;
  public count: number;
  public query: string;
  public active: boolean;

  constructor() {
    this.label = '';
    this.count = 0;
    this.query = '';
    this.active = false;
  }

  public createQuery(
    q: string,
    facetFilters: SearchFacetFilter[],
    rangeQueries: SearchFacetRangeFilter[]
  ) {
    let queryString = '';
    queryString = this.appendQueryString(queryString, 'f=');

    let activeFilter: SearchFacetFilter | null = null;
    let foundToken = false;

    for (const facetFilter of facetFilters) {
      if (
        facetFilter.token === this.token &&
        facetFilter.value === this.value
      ) {
        activeFilter = facetFilter;
        foundToken = true;
        this.active = true;
        continue;
      } else if (facetFilter.token === this.token) {
        continue;
      }

      queryString +=
        facetFilter.token + ':' + this.urlEncode(facetFilter.value) + ';';
    }

    let activeRangeQuery: SearchFacetRangeFilter | null = null;
    for (const rangeQuery of rangeQueries) {
      if (rangeQuery.token === this.token && rangeQuery.value === this.value) {
        activeRangeQuery = rangeQuery;
        foundToken = true;
        this.active = true;
        continue;
      } else if (rangeQuery.token === this.token) {
        continue;
      }

      queryString +=
        rangeQuery.token + ':' + this.urlEncode(rangeQuery.value) + ';';
    }

    if (foundToken === false) {
      queryString += this.token + ':' + this.urlEncode(this.value);
    }

    if (queryString.endsWith(';')) {
      queryString = queryString.substr(0, queryString.length - 1);
    }

    if (queryString === 'f=') {
      queryString = '';
    }

    if (activeFilter) {
      activeFilter.query = queryString;
      this.active = true;
    }

    if (activeRangeQuery) {
      activeRangeQuery.query = queryString;
      this.active = true;
    }

    this.query = queryString;
  }

  private appendQueryString(queryString: string, appendString: string) {
    let appendedQueryString: string;

    if (!queryString) {
      appendedQueryString = '';
    } else {
      appendedQueryString = queryString + '&';
    }

    appendedQueryString += appendString;

    return appendedQueryString;
  }

  private urlEncode(text: string): string {
    const encodedText = encodeURIComponent(text);
    return encodedText;
  }
}
